import React, { FC } from "react";
import classNames from "classnames";

export const Meta: FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div
      className={classNames(
        "mt-10 flex flex-col flex-wrap gap-10",
        "sm:flex-row sm:items-end sm:justify-between",
      )}
    >
      <img
        src="/images/moneyland-ch.svg"
        alt="moneyland.ch"
        className="w-[130px]"
      />
      <p className="text-small text-primary-content">
        © Alpian {currentYear}. All rights reserved.
      </p>
    </div>
  );
};
